import { render, staticRenderFns } from "./addInventoryDialog.vue?vue&type=template&id=55a83059&scoped=true&"
import script from "./addInventoryDialog.vue?vue&type=script&lang=ts&"
export * from "./addInventoryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./addInventoryDialog.vue?vue&type=style&index=0&id=55a83059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a83059",
  null
  
)

export default component.exports